import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1 } from '../../StyledComponents';
import Deploy from '../../../assets/v2/kiosk/group-23.svg';
import Lock from '../../../assets/v2/kiosk/remote-view.svg';
import Remote from '../../../assets/v2/kiosk/custome-screen.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BottomBanner } from '../BottomBanner';
// import LinkedIn from '../../../assets/Footer/linkedin.svg';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
    background: #fafcff;
  }
`;

const SectionHeading = styled(H1)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.28;
  letter-spacing: normal;
  text-align: center;
  color: #4a5376;
  grid-column: span 12;
  @media (max-width: 520px) {
    font-size: 28px;
  }
`;

const Grid = styled.div`
  display: grid;
  margin-top: 3rem;
  @media (min-width: 520px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 2rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 5rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: center;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 5rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const FounderName = styled(H2)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #4d3df4;
`;

const SectionLeftImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: end;
  @media (max-width: 520px) {
    margin-left: 0rem;
  }
`;
const FounderImgShiv = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (max-width: 520px) {
    display: none;
  }
`;
const FounderImgMobile = styled(LazyLoadImage)`
  width: 80%;
  justify-self: center;
  margin-left: 1rem;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
  }
`;
const SectionSubHeadingRight = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  padding-left: 6rem;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0rem;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: justify;
    width: 90%;
  }
`;

const FounderExpShiv = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  padding-left: 6rem;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    gitppadding-right: 4rem;
  }
`;
export default () => (
  <div>
    <Section>
      <SectionHeading>
        Benefits of Esper Kiosk Management Solution
      </SectionHeading>
      <Grid>
        <ImgWrapper>
          <SectionLeftImage
            src={Deploy}
            alt="Configuring Devices to Run in Android Kiosk Mode"
          />
        </ImgWrapper>
        <GridItem>
          <SectionSubHeading>
            Configuring Devices to Run in Android Kiosk Mode
          </SectionSubHeading>
          <SectionContent>
            Find scalable solutions with Esper to help enterprises restrict
            applications on the kiosks. We give you everything you need to build
            a truly locked down Kiosk from the hardware level on up, and secure
            all of your Kiosk devices.
          </SectionContent>
        </GridItem>
      </Grid>
      <Grid>
        <GridItemRight>
          <FounderImgMobile
            src={Lock}
            alt="Lock Devices and Gain Complete Control"
          />
          <SectionSubHeadingRight>
            Remotely View and Control Kiosks
          </SectionSubHeadingRight>
          <FounderExpShiv>
            Lock, debug and manage from anywhere. Esper helps you remotely lock
            and wipe the data to secure your Kiosks from being compromised. You
            can also diagnose system failures without the risk of intrusions.
          </FounderExpShiv>
        </GridItemRight>
        <ImgWrapper>
          <FounderImgShiv src={Lock} alt="Remote Control and Debugging" />
        </ImgWrapper>
      </Grid>
      <Grid>
        <ImgWrapper>
          <SectionLeftImage src={Remote} alt="Remote Control and Debugging" />
        </ImgWrapper>
        <GridItem>
          <SectionSubHeading>
            Customize Kiosks According to Your Needs
          </SectionSubHeading>
          <SectionContent>
            We make your work simple. Period. Esper allows you to easily
            integrate functionality into a new or existing Kiosk app that our
            team will design exclusively for your company’s or customer’s use.
          </SectionContent>
        </GridItem>
      </Grid>
    </Section>
    <BottomBanner
      description={`Step-by-step process to build your Android apps in kiosk mode using Esper `}
      buttonText={'Start Now'}
      link="https://blog.esper.io/best-way-to-build-android-apps-in-kiosk-mode/"
    />
  </div>
);
